import { render } from "./IconArrowRight.vue?vue&type=template&id=a8b62d62"
const script = {}

import "./IconArrowRight.vue?vue&type=style&index=0&id=a8b62d62&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__